<template>
  <div class="help-buyTip-view">
    <section class="module">
      <div class="m-body">
        <div class="sub-title mt0">报名注意事项：</div>
        <ul class="discription mt10">
          <li>家长请用孩子的真实姓名注册账号(昵称)，确保分班后孩子和班主任的真实互动。</li>
          <li>请扫码加微信客服，客服先为孩子开通账号和分班，家长确认账号可正常使用后再进行缴费。</li>
          <li>注册并完成付费后，课程24小时开放，学习内容不受限。</li>
        </ul>
        <div class="sub-title">购买时长：</div>
        <el-row class="category w800 mt10">
          <el-col v-for="item in category" :key="item.duration" :class="item.recommend ? 'recommend' : ''" :span="12">
            <img :src="recommend" alt="" v-if="item.recommend" />
            <div>时长：<span class="f18 strong">{{item.duration}}</span></div>
            <div>原价：<span class="orgPrice">{{item.orgPrice}}</span>元</div>
            <div>优惠价：<span class="price">{{item.price}}</span>元</div>
          </el-col>
        </el-row>
        <div class="sub-title">购买方式：</div>
        <div class="connect mt10">
          <div class="mt10">请联系爱听客服进行购买与付费：{{connect.name}}（<span class="mobile">{{connect.mobile}}</span>）</div>
          <el-row class="w800 mt10">
            <el-col :span="12">
              <div>客服：</div>
              <img :src="connect.serviceWx" alt="" />
            </el-col>
            <el-col :span="12">
              <div>订阅号：</div>
              <img :src="connect.subscribe" alt="" />
            </el-col>
          </el-row>
        </div>
        <img src="/static/img/buyTip-bg.png" alt="" class="tip-bg" />
      </div>
    </section>
  </div>
</template>

<script>
let recommend = require('assets/image/recommend.png')
export default {
  name: 'userCenter',
  data () {
    return {
      category: window.buyConfig.category,
      connect: window.buyConfig.connect,
      recommend
    }
  },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '帮助中心' }, { name: '购买须知' }])
  }
}
</script>

<style lang="scss">
.help-buyTip-view {
  .m-body{
    padding-left: 28px;
  }
  .sub-title {
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-top: 30px;
    margin-left: -20px;
  }
  .f18 {
    font-size: 18px;
  }
  .w800 {
    width: 100%;
    max-width: 800px;
    min-width: 550px;
  }
  .category {
    line-height: 2em;
    .el-col {
      position: relative;
      &.recommend {
        padding-left: 45px;
        img {
          width: 80px;
          height: 80px;
          position: absolute;
          left: -20px;
          top: -10px;
          // opacity: 0.5;
          transform: rotate(-51deg);
        }
      }
    }
    .orgPrice {
      color: #999;
      text-decoration: line-through;
    }
    .price {
      color: #ff5a60;
      font-size: 32px;
      font-weight: bold;
    }
  }
  .connect {
    .mobile {
      font-weight: bold;
      font-size: 18px;
      color: #000;
    }
    img {
      width: 80%;
    }
  }
  .discription {
    margin-left: 16px;
    li {
      padding: 8px 0;
      list-style: decimal;
    }
  }
  .tip-bg {
    display: none;
  }
  @media screen and (min-width: 1150px) {
    .tip-bg {
      display: block;
      position: absolute;
      right: 20px;
      top: 20px;
      width: calc(100% - 700px);
      max-width: 600px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/help/buyTip.vue